import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { Register } from '@xanadu/core';
import { TreeSignal, NoticeSignal } from '@xanadu/signal';
import { Cast } from '@xanadu/model';
import { FormGroup } from '@angular/forms';
import { CastCache } from '@xanadu/cache';

@Component({
    selector: 'app-cast',
    templateUrl: './cast.component.html',
    styleUrls: ['./cast.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('cast')
export class CastComponent {
    private readonly treeSignal = inject(TreeSignal);
    private readonly noticeSignal = inject(NoticeSignal);
    private readonly castCache = inject(CastCache);

    readonly model = input<any>();
    readonly formGroup = input<FormGroup<any>>();

    metaCast: any = { id: 'cast', name: 'Cast', info: 'Import cast function', value: '_id', label: 'name' };
    metaResult: any = { id: 'result', name: 'Cast result', rows: 18 };

    cast?: Cast;

    formResult: FormGroup = new FormGroup({});

    private source: any;
    private target: any;

    constructor() {
        effect(() => {
            const casts = this.castCache.signal();
            const model = this.model();

            if (casts) {
                this.metaCast.options = [...casts?.values()];
            }
            if (model?.cast) {
                this.onCast(model.cast);
            }
        });

        effect(() => {
            const response = this.treeSignal.importResponse();

            this.source = response;
            this.formResult.patchValue({ result: null });
        });


        effect(() => {
            this.treeSignal.importConvert();
            this.convert();
        });


        effect(() => {
            const casts = this.castCache.signal();

            if (this.metaCast.options) {
                this.metaCast.options.length = 0;
                if (casts) {
                    this.metaCast.options.push(...casts.values());
                }
            }
            if (this.cast) {
                this.onCast(this.cast._id);
            }
        });
    }

    public onCast(event: any) {
        this.cast = this.castCache.signal()?.get(event);
        this.treeSignal.importCast.set(this.cast);
        this.formResult.patchValue({ result: undefined });
        this.treeSignal.importResult.set(undefined);
    }

    public onJson(event: string) {
        if (this.formResult.valid && !this.formResult.pristine) {
            const obj = JSON.parse(event);
            this.treeSignal.importResult.set(obj);
        } else {
            this.treeSignal.importResult.set(undefined);
        }
    }

    private convert() {
        if (this.cast && this.source) {
            try {
                this.target = this.runFunction(this.cast.data.script);
                const result = JSON.stringify(this.target, null, 4);
                this.formResult.patchValue({ result });
                this.treeSignal.importResult.set(this.target);
            } catch (e) {
                this.noticeSignal.error((e as Error).message);
            }
        }
    }

    private runFunction(script: string) {
        return new Function(`return (${script});`)()(this.source);
    }
}
